export default "__VITE_ASSET__HVOwAyGA__"